export const ID_AUSTRIA = 1
export const ID_BELGIUM = 2
export const ID_FRANCE = 3
export const ID_IRELAND = 4
export const ID_LUXEMBOURG = 5
export const ID_PORTUGAL = 6
export const ID_SPAIN = 7
export const ID_SWIRTZERLAND = 8
export const ID_UK = 9
export const ID_USA = 10
export const ID_BRASIL = 11
export const ID_EUROPE = 20
